module.exports = __webpack_public_path__ + "media/images/brand/page_background/left_side_spots-7c3f001ca53939b478da2b1f1c34c269.svg";